// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__32KFg","icon":"SortAdornment_icon__3-Qyt","up":"SortAdornment_up__3jGpO","down":"SortAdornment_down__3WJJJ","active":"SortAdornment_active__1jCco"};